export const ft = 3.28
export const MIN_RADIUS_IN_METER = 60.96
export const MAX_RADIUS_IN_METER = 609.6
export const roundMetersTo5Feet = (value: number) => Math.round(value * ft / 5) * 5